<template>
  <div ref="sidebar" class="sidebar">
    <top-list />
    <board-list />
    <button
      ref="toggle"
      class="toggle"
      :class="{ open: showSidebar }"
      @click="onClickToggle"
    >
      <svg-icon
        class="icon-expand-right"
        :width="'16'"
        :height="'16'"
        icon="app-icons/expand-right"
      />
    </button>
    <div class="button globalVars" @click="onClickGlobalVars">
      <svg-icon
        class="icon-global-vars"
        :width="'18'"
        :height="'18'"
        icon="app-icons/earth"
      />
      Global variables
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TopList from './TopList.vue';
import BoardList from './BoardList.vue';
import SvgIcon from '../all/SvgIcon.vue';

export default {
  components: {
    'top-list': TopList,
    'board-list': BoardList,
    SvgIcon,
  },

  data() {
    return {
      showSidebar: false,
      window: {
        width: 0,
        height: 0,
      },
    };
  },

  computed: {},

  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },

  mounted() {
    if (this.window.width <= 768) {
      $(this.$refs.sidebar).css('width', '190px');
      this.closeSidebar();
    }
    $(this.$el).resizable({
      minWidth: 140,
      maxWidth: 340,
      handles: 'e',
    });
    $(this.$el).on('resize', this.onSidebarResize);
    $(this.$refs.sidebar).css('transition', 'transform 0.25s ease-in-out');
  },

  unmounted() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    ...mapActions('application/modals', ['setGlobalVarsModal']),

    closeSidebar() {
      $(this.$refs.sidebar).css(
        'transform',
        `translateX(-${$(this.$refs.sidebar).width()}px)`
      );
      this.showSidebar = false;
    },

    openSidebar() {
      $(this.$refs.sidebar).css('transform', `translateX(0px)`);
      this.showSidebar = true;
    },

    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width <= 768) {
        this.closeSidebar();

        // $(this.$refs.toggle).css('display', 'block');
      } else {
        this.openSidebar();
        // $(this.$refs.toggle).css('display', 'none');
      }
    },

    onSidebarResize() {
      $('.ui').innerWidth($('.panzoom-parent').innerWidth());
    },

    onClickToggle() {
      const elem = this.$refs.sidebar;
      const width = $(elem).width();
      if (this.showSidebar) {
        $(this.$refs.sidebar).css(
          'transform',
          `translateX(-${$(this.$refs.sidebar).width()}px)`
        );
        this.showSidebar = false;
      } else {
        $(this.$refs.sidebar).css('transform', `translateX(0px)`);
        this.showSidebar = true;
      }
    },

    onClickGlobalVars() {
      console.log('GLOBALVARS CLICKED');
      this.setGlobalVarsModal({ value: true });
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 260px;
  background: #2c3233;
  z-index: 100;
  box-shadow: 2px 3px 6px 0 rgba(0, 0, 0, 0.2);
  position: relative;
  height: 100%;
  z-index: 99;
  @media (hover: none), only screen and (max-width: 768px) {
    position: absolute;
  }
  .toggle {
    display: none;
    position: absolute;
    right: -40px;
    top: 50%;
    width: 40px;
    height: 40px;
    border-radius: 0 3px 3px 0;
    border: none;
    background: #3e4748;
    margin-top: -20px;
    z-index: 91;
    cursor: pointer;
    color: #db841e;
    padding: 0;
    box-shadow: inset 3px 0px 6px -2px rgba(0, 0, 0, 0.2);
    @media (hover: none), only screen and (max-width: 768px) {
      display: block;
    }

    .icon-expand-right {
      transform: rotate(0);
      transition: transform 0.25s;
    }
    &.open .icon-expand-right {
      transform: rotate(180deg);
    }
  }
}
</style>

<style lang="scss">
.sidebar .folder_container .vddl-placeholder {
  left: 22px;
}

.sidebar .dragover .folder_container.empty .vddl-list,
.sidebar .dragover .folder_container.collapsed .vddl-list {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}

.sidebar .folder_container.empty .vddl-list,
.sidebar .item_container.empty .vddl-list {
  min-height: 0;
}

.sidebar .dragover .folder_container.empty .vddl-list .vddl-placeholder,
.sidebar .dragover .folder_container.collapsed .vddl-list .vddl-placeholder {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  border: 1px solid #fff;
  z-index: 999;
  height: auto;
  width: auto;
  background: none;
  display: block !important;
  color: transparent;

  // display:none;
  &:after {
    display: none;
  }
}

.sidebar .folder_container.collapsed .vddl-list .vddl-draggable {
  display: none;
}

.sidebar .vddl-list.panel__body--list {
  padding-top: 1px;
  margin-bottom: 1px;
}

.sidebar .ui-resizable-handle {
  position: absolute;
  font-size: 0.1px;
  opacity: 0;
  -ms-touch-action: none;
  touch-action: none;
  z-index: auto !important;
  background: #fff;
}

.sidebar .ui-resizable-handle:hover,
.sidebar .ui-resizable-resizing .ui-resizable-handle {
  opacity: 0.1;
}

.sidebar .ui-resizable-n {
  cursor: n-resize;
  height: 5px;
  width: 100%;
  top: -4px;
  left: 0;
}

.sidebar .ui-resizable-e {
  cursor: e-resize;
  height: 100%;
  width: 4px;
  top: 0;
  right: -4px;
  opacity: 0 !important;
}

/*** COMPONENT LIST & BOARD LIST COMMON STYLES ****/

.dragCanvasSidebar {
  overflow: hidden;
  display: block;
  position: absolute;
  left: -50000px;
  background: rgba(0, 0, 0, 1);
  border: 1px solid #5c6263;
  border-radius: 999px;
}

.sidebar .vddl-dragging {
  opacity: 0.7;
}

.sidebar .vddl-dragging-source {
  display: none;
}

.sidebar .vddl-draggable,
.sidebar .vddl-list {
  width: 100%;
  // min-height: 30px;
  line-height: 30px;
  padding: 0 0;
  box-sizing: border-box;
}

.sidebar .vddl-placeholder {
  background: #fff;
  position: relative;
  &:after {
    content: '';
    position: absolute;
    z-index: 1000;
    right: 0;
    bottom: 0;
    left: 0;
    height: 2px;
    background: #fff;
  }
}

.dragging .sidebar .item:after,
.dragging .sidebar .element:after,
.dragging .sidebar .folder:after {
  display: none;
}

.sidebar .collapsed .vddl-list.panel__body {
  min-height: inherit;
  line-height: inherit;
}

.sidebar .vddl-draggable {
  padding-left: 8px;
  border-top: 0px solid transparent;
  margin: 0 0 2px;
  .item:hover:after,
  .folder:hover:after,
  .item.selected:after,
  .folder.selected:after {
    content: '';
    position: absolute;
    background: #3e4748;
    opacity: 0.5;
    top: 0;
    bottom: 0;
    right: 0;
    width: 380px;
    z-index: -1;
  }

  &.popupon > .item:after,
  &.popupon > .folder_container > .folder:after {
    background: #3e4748 !important;
    opacity: 0.5;
  }

  &.popupon > .item,
  &.popupon > .folder_container > .folder {
    .v-popover {
      background: #2c3132;
    }
  }

  .vddl-draggable {
    padding-left: 27px;
  }

  .vddl-list {
    margin: 2px 0 0;
  }
}

.dragCanvasSidebar {
  overflow: hidden;
  display: block;
  position: absolute;
  left: -50000px;
  background: rgba(0, 0, 0, 1);
  border: 1px solid #5c6263;
  border-radius: 999px;
}

.create_popup.tooltip.popover {
  margin-top: 0;
  .popover-arrow {
    display: none;
  }
  .popover-inner {
    background: #0d0e0e;
    border-radius: 3px;
    overflow: hidden;
    // width: 120px;
    border: 1px solid #414c4d;
    -webkit-box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.25);
    box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.25);
    padding: 0;
    .input-hidden {
      display: none;
    }
    .option {
      padding: 8px 16px;
      cursor: pointer;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;

      &:hover {
        background: #363e3f;
      }
      .label {
        flex: 1;
      }
    }
  }
}

.sidebar .button.globalVars {
  z-index: 1;
  width: 100%;
  height: 34px;
  background: none;
  border-top: 1px solid rgba(62, 71, 71, 0.75);
  // border-top: 1px solid #41494a;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #bcbcbc;
  background: #2c3233;
  font-size: 12px;
  &:hover {
    background: #353c3e;
    border-top: 1px solid rgba(62, 71, 71, 0.5);
  }
  .svg-icon-container {
    margin: 0 9px;
  }
}

// SIDEBAR SCROLLBAR STYLES

.sidebar .board-list > .list,
.sidebar .comp_list > .list {
  scrollbar-color: rgba(0, 0, 0, 0.5) transparent;
  scrollbar-width: thin;
  overflow: hidden;
  height: 100%;
  @media (hover: none), only screen and (max-width: 768px) {
    overflow-y: auto !important;
  }
  &:hover {
    overflow-y: auto !important;
    overflow: overlay !important;
  }
}

.sidebar .list::-webkit-scrollbar {
  width: 10px;
}

.sidebar .list::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.5);
  border: 2px solid transparent;
  border-radius: 999px;
  background-clip: padding-box;
}

.sidebar .list::-webkit-scrollbar-button {
  display: none;
}
</style>
